type BreadcrumbsPlaceholderProps = {
  className?: string;
};

/**
 * Reserves the rendered Breadcrumbs row while a route-level client boundary
 * hydrates. Breadcrumbs is 36px tall (including vertical padding) before its
 * caller's margin is applied.
 */
export default function BreadcrumbsPlaceholder({ className = '' }: BreadcrumbsPlaceholderProps) {
  return (
    <div className={`h-9 px-1 ${className}`} aria-hidden="true">
      <div className="mt-3 h-3 w-32 rounded bg-gray-100 motion-safe:animate-pulse" />
    </div>
  );
}
